var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ApiClient } from '../../api/apiClient';
import { SelectedVehicle } from '../vehicle/selectedVehicle';
import { useForm } from '../../context/FormContext';
import { trackCustomerDetails } from '../../utils/analytics';
export var CustomerDetails = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
    var onNext = _a.onNext, onBack = _a.onBack, formData = _a.formData, refreshData = _a.refreshData;
    var formState = useForm().state;
    // Form field states with initial values from props or fallback to window settings
    var _10 = useState(''), firstName = _10[0], setFirstName = _10[1];
    var _11 = useState(''), lastName = _11[0], setLastName = _11[1];
    var _12 = useState(''), email = _12[0], setEmail = _12[1];
    var _13 = useState(''), phone = _13[0], setPhone = _13[1];
    var _14 = useState(''), state = _14[0], setState = _14[1];
    var _15 = useState(''), stateName = _15[0], setStateName = _15[1];
    var _16 = useState(''), postcode = _16[0], setPostcode = _16[1];
    var _17 = useState(''), closestLocation = _17[0], setClosestLocation = _17[1];
    // States dropdown data
    var _18 = useState([]), states = _18[0], setStates = _18[1];
    var _19 = useState(false), isLoadingStates = _19[0], setIsLoadingStates = _19[1];
    // Locations dropdown data
    var _20 = useState([]), locations = _20[0], setLocations = _20[1];
    var _21 = useState(false), isLoadingLocations = _21[0], setIsLoadingLocations = _21[1];
    // Form submission state
    var _22 = useState(false), isSubmitting = _22[0], setIsSubmitting = _22[1];
    var _23 = useState(null), formError = _23[0], setFormError = _23[1];
    var _24 = useState(null), emailError = _24[0], setEmailError = _24[1];
    var _25 = useState(null), phoneError = _25[0], setPhoneError = _25[1];
    var _26 = useState(false), isLoadingSavedData = _26[0], setIsLoadingSavedData = _26[1];
    // Australian phone number validation regex - must start with 0 and be exactly 10 digits
    var ausPhonePattern = /^0\d{9}$/;
    // Phone validation function
    var validatePhone = function (phone) {
        return ausPhonePattern.test(phone.replace(/\s+/g, '')); // Remove spaces before testing
    };
    // Initialize form fields from formData prop or fallback to tiofSettings
    useEffect(function () {
        var _a;
        // Get data from props or fall back to window settings
        var savedData = formData || ((_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) || {};
        // Update form fields with the latest data
        setFirstName(savedData.first_name || '');
        setLastName(savedData.last_name || '');
        setEmail(savedData.u_email || '');
        setPhone(savedData.u_phone || '');
        setState(savedData.u_state || '');
        setStateName(savedData.u_state_name || '');
        setPostcode(savedData.u_postcode || '');
        setClosestLocation(savedData.u_closest_location || '');
        setIsLoadingSavedData(false);
    }, [formData]); // Re-run when formData prop changes
    // Fetch states on component mount
    useEffect(function () {
        var isMounted = true;
        var fetchStates = function () { return __awaiter(void 0, void 0, void 0, function () {
            var statesData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isMounted)
                            return [2 /*return*/];
                        setIsLoadingStates(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApiClient.fetchStates()];
                    case 2:
                        statesData = _a.sent();
                        if (isMounted) {
                            setStates(statesData);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setIsLoadingStates(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchStates();
        // Cleanup function to handle component unmounting
        return function () {
            isMounted = false;
        };
    }, []); // Empty dependency array to run only once
    // Fetch all locations on component mount (not filtered by state)
    useEffect(function () {
        var isMounted = true;
        var fetchLocations = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, locationsList, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isMounted)
                            return [2 /*return*/];
                        setIsLoadingLocations(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApiClient.fetchAvailableLocations()];
                    case 2:
                        response = _a.sent();
                        if (isMounted && response.success && response.data) {
                            locationsList = response.data.map(function (loc) { return ({
                                id: loc.id,
                                name: loc.name
                            }); });
                            setLocations(locationsList);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        if (isMounted) {
                            setIsLoadingLocations(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchLocations();
        // Cleanup function to handle component unmounting
        return function () {
            isMounted = false;
        };
    }, []); // Empty dependency array to run only once
    // Handle form submission
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var emailRegex, customerData, result, scriptEl, refreshedData, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    // Basic validation
                    if (!firstName || !lastName || !email || !phone || !state || !postcode || !closestLocation) {
                        setFormError('Please fill in all required fields');
                        return [2 /*return*/];
                    }
                    emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(email)) {
                        setEmailError('Please enter a valid email address');
                        return [2 /*return*/];
                    }
                    // Phone validation
                    if (!validatePhone(phone)) {
                        setPhoneError('Please enter a valid 10-digit mobile number starting with 0.');
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    setFormError(null);
                    setEmailError(null);
                    setPhoneError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 9, 10, 11]);
                    customerData = {
                        first_name: firstName,
                        last_name: lastName,
                        email: email,
                        phone: phone,
                        state: state,
                        state_name: stateName,
                        postcode: postcode,
                        closest_location: closestLocation
                    };
                    return [4 /*yield*/, ApiClient.submitCustomerDetails(customerData)];
                case 2:
                    result = _a.sent();
                    if (!result.success) return [3 /*break*/, 7];
                    if (!result.js_update) return [3 /*break*/, 4];
                    scriptEl = document.createElement('div');
                    scriptEl.innerHTML = result.js_update;
                    document.body.appendChild(scriptEl);
                    // Give the script a moment to execute
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 50); })];
                case 3:
                    // Give the script a moment to execute
                    _a.sent();
                    // Clean up
                    document.body.removeChild(scriptEl);
                    _a.label = 4;
                case 4:
                    if (!refreshData) return [3 /*break*/, 6];
                    return [4 /*yield*/, refreshData()];
                case 5:
                    refreshedData = _a.sent();
                    _a.label = 6;
                case 6:
                    // Track customer details submission (Step 2)
                    trackCustomerDetails();
                    onNext();
                    return [3 /*break*/, 8];
                case 7:
                    // Handle error from server
                    setFormError(result.error || 'Failed to save customer details. Please try again.');
                    _a.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9:
                    err_1 = _a.sent();
                    setFormError('Failed to save customer details. Please try again.');
                    return [3 /*break*/, 11];
                case 10:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    // Additional debugging callback
    var handleBackWithLogging = function () {
        if (refreshData) {
            refreshData().then(function (data) {
                onBack();
            });
        }
        else {
            onBack();
        }
    };
    return (_jsxs("div", { className: "customer-details", children: [formState.vehicleDetails && (_jsx(SelectedVehicle, { vehicle: formState.vehicleDetails, vehicleRego: formState.entryMethod === 'rego' ? ((_b = formState.regoDetails) === null || _b === void 0 ? void 0 : _b.rego) || '' : ((_c = formState.manualLookupDetails) === null || _c === void 0 ? void 0 : _c.rego) || '', onNotYourCar: onBack })), _jsxs("form", { onSubmit: handleSubmit, className: "max-500", children: [_jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "first_name", children: ((_f = (_e = (_d = window.tiofSettings) === null || _d === void 0 ? void 0 : _d.i18n) === null || _e === void 0 ? void 0 : _e.customerDetails) === null || _f === void 0 ? void 0 : _f.firstname) || 'First Name' }), _jsx("input", { type: "text", id: "first_name", name: "first_name", value: firstName, onChange: function (e) { return setFirstName(e.target.value); }, required: true, disabled: isSubmitting })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "last_name", children: ((_j = (_h = (_g = window.tiofSettings) === null || _g === void 0 ? void 0 : _g.i18n) === null || _h === void 0 ? void 0 : _h.customerDetails) === null || _j === void 0 ? void 0 : _j.lastname) || 'Last Name' }), _jsx("input", { type: "text", name: "last_name", id: "last_name", value: lastName, onChange: function (e) { return setLastName(e.target.value); }, required: true, disabled: isSubmitting })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "email", children: ((_m = (_l = (_k = window.tiofSettings) === null || _k === void 0 ? void 0 : _k.i18n) === null || _l === void 0 ? void 0 : _l.customerDetails) === null || _m === void 0 ? void 0 : _m.email) || 'Email' }), _jsx("input", { type: "email", name: "email", id: "email", value: email, onChange: function (e) { return setEmail(e.target.value); }, onBlur: function (e) {
                                    // Validate on blur
                                    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    if (e.target.value && !emailRegex.test(e.target.value)) {
                                        setEmailError('Please enter a valid email address');
                                    }
                                    else {
                                        setEmailError(null);
                                    }
                                }, required: true, disabled: isSubmitting }), emailError && (_jsx("div", { className: "error-message", children: emailError }))] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "phone", children: ((_q = (_p = (_o = window.tiofSettings) === null || _o === void 0 ? void 0 : _o.i18n) === null || _p === void 0 ? void 0 : _p.customerDetails) === null || _q === void 0 ? void 0 : _q.phone) || 'Mobile' }), _jsx("input", { type: "tel", name: "phone", id: "phone", value: phone, onChange: function (e) {
                                    // Only allow numbers and spaces
                                    var value = e.target.value.replace(/[^\d\s]/g, '');
                                    setPhone(value);
                                }, onBlur: function (e) {
                                    // Validate on blur
                                    if (e.target.value && !validatePhone(e.target.value)) {
                                        setPhoneError('Please enter a valid 10-digit mobile number starting with 0.');
                                    }
                                    else {
                                        setPhoneError(null);
                                    }
                                }, onKeyPress: function (e) {
                                    // Allow only numbers and spaces
                                    if (!/[\d\s]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }, required: true, disabled: isSubmitting, maxLength: 10 }), phoneError && (_jsx("div", { className: "error-message", children: phoneError }))] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "state", children: ((_t = (_s = (_r = window.tiofSettings) === null || _r === void 0 ? void 0 : _r.i18n) === null || _s === void 0 ? void 0 : _s.customerDetails) === null || _t === void 0 ? void 0 : _t.state) || 'State' }), _jsxs("select", { id: "state", name: "state", value: state, onChange: function (e) {
                                    var selectedStateId = e.target.value;
                                    var selectedState = states.find(function (s) { return s.StateId.toString() === selectedStateId; });
                                    setState(selectedStateId);
                                    setStateName((selectedState === null || selectedState === void 0 ? void 0 : selectedState.StateName) || '');
                                }, required: true, disabled: isLoadingStates || isSubmitting, children: [_jsx("option", { value: "", children: ((_w = (_v = (_u = window.tiofSettings) === null || _u === void 0 ? void 0 : _u.i18n) === null || _v === void 0 ? void 0 : _v.customerDetails) === null || _w === void 0 ? void 0 : _w.selectState) || 'Select State' }), states && states.length > 0 ? (states.map(function (stateOption, index) { return (_jsx("option", { value: stateOption.StateId, children: stateOption.StateName }, stateOption.StateId || "state-".concat(index))); })) : (_jsx("option", { disabled: true, children: isLoadingStates ? 'Loading states...' : 'No states available' }))] })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "closest_location", children: ((_z = (_y = (_x = window.tiofSettings) === null || _x === void 0 ? void 0 : _x.i18n) === null || _y === void 0 ? void 0 : _y.customerDetails) === null || _z === void 0 ? void 0 : _z.closestLocation) || 'Nearest Sell My Car Location' }), _jsxs("select", { id: "closest_location", name: "closest_location", value: closestLocation, onChange: function (e) {
                                    setClosestLocation(e.target.value);
                                }, required: true, disabled: isLoadingLocations || isSubmitting, children: [_jsx("option", { value: "", children: ((_2 = (_1 = (_0 = window.tiofSettings) === null || _0 === void 0 ? void 0 : _0.i18n) === null || _1 === void 0 ? void 0 : _1.customerDetails) === null || _2 === void 0 ? void 0 : _2.selectClosestLocation) || 'Select Nearest Sell My Car Location' }), locations && locations.length > 0 ? (locations.map(function (location, index) { return (_jsx("option", { value: location.id, children: location.name }, location.id || "location-".concat(index))); })) : (_jsx("option", { disabled: true, children: isLoadingLocations ? 'Loading locations...' : 'No locations available' }))] })] }), _jsxs("div", { className: "form-group full-width", children: [_jsx("label", { htmlFor: "postcode", children: ((_5 = (_4 = (_3 = window.tiofSettings) === null || _3 === void 0 ? void 0 : _3.i18n) === null || _4 === void 0 ? void 0 : _4.customerDetails) === null || _5 === void 0 ? void 0 : _5.postcode) || 'Postcode' }), _jsx("input", { type: "text", name: "postcode", id: "postcode", value: postcode, onChange: function (e) { return setPostcode(e.target.value); }, required: true, disabled: isSubmitting, maxLength: 6 })] }), _jsx("div", { className: "form-group half-width pad-top-25 text-right", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: handleBackWithLogging, disabled: isSubmitting, children: ((_7 = (_6 = window.tiofSettings) === null || _6 === void 0 ? void 0 : _6.i18n) === null || _7 === void 0 ? void 0 : _7.previous) || 'Back' }) }), _jsx("div", { className: "form-group pad-top-25 half-width", children: _jsx("button", { type: "submit", className: "button icon-right", disabled: isSubmitting, children: isSubmitting
                                ? 'Saving...'
                                : (((_9 = (_8 = window.tiofSettings) === null || _8 === void 0 ? void 0 : _8.i18n) === null || _9 === void 0 ? void 0 : _9.continue) || 'Continue') }) }), formError && (_jsx("div", { className: "error-message", children: formError }))] })] }));
};
